"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const React = __importStar(require("react"));
class App {
    constructor() {
        // Initialize window scope
        window.Bolt = window.Bolt || {};
        window.Bolt.Lattice = window.Bolt.Lattice || {};
        window.Bolt.Lattice.styles = window.Bolt.Lattice.styles || {};
        window.Bolt.Lattice.appVersion = APP_VERSION;
        // Pass the reference to the window, so module setup can reference the object
        window.Bolt.Lattice.app = this;
        // Let's have top level unhandled rejection handlers
        // so other plugins / additions do not get the exceptions that we have already handled
        let unhandledrejectionHandlers = [];
        window.Bolt.addUnhandledRejectionHandler = (handler) => {
            unhandledrejectionHandlers.push(handler);
        };
        window.Bolt.removeUnhandledRejectionHandler = (handler) => {
            unhandledrejectionHandlers = unhandledrejectionHandlers.filter((element) => element !== handler);
        };
        window.addEventListener("unhandledrejection", (e) => {
            unhandledrejectionHandlers.forEach((handler) => {
                handler(e);
            });
        });
        // Create a "callback" hook on the window scope, so once initrc
        // file is loaded we will assign it to global variable for lattice-runtime to consume it
        window.initrc_load = (initrc) => {
            window.Bolt.Lattice.initrc = initrc;
        };
        // Memo render function, so we will not cause unexpected re-renders
        this.render = React.memo(this.render.bind(this));
    }
    init(services) {
        services.publisher.publish({
            type: "app-init",
        });
    }
    setup() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadScript(`/initrc.js?${Date.now()}`, false);
            let LatticeBoostrap;
            if (process.env.NODE_ENV === "development") {
                LatticeBoostrap = require("../../build/runtime/lattice-runtime.development").Lattice;
            }
            else {
                LatticeBoostrap = require("../../build/runtime/lattice-runtime").Lattice;
            }
            LatticeBoostrap.init(this);
        });
    }
    setTitle(title) {
        document.title = title;
    }
    initializeGoogleAnalytics(options) {
        window.dataLayer = window.dataLayer || [];
        window.Bolt.tracking = window.Bolt.tracking || {};
        window.Bolt.tracking.googleAnalyticsId = options.tagId;
        window.gtag = function gtag() {
            // eslint-disable-next-line prefer-rest-params -- Google analytics actually needs arguments value, deconstruction will not work here
            window.dataLayer.push(arguments);
        };
        window.gtag("js", new Date());
        window.gtag("config", options.tagId);
        this.loadScript(`https://www.googletagmanager.com/gtag/js?id=${options.tagId}`, true);
    }
    loadApplog(options) {
        window.Bolt = window.Bolt || {};
        window.Bolt.AppLog = window.Bolt.AppLog || {};
        window.Bolt.AppLog.onload = (instance) => {
            const [major, minor] = APP_VERSION.split(".");
            const appVersion = `${options.prefix}.${major}.${Number(minor) < 10 ? `0${minor}` : minor}`;
            instance.set("appVersion", appVersion);
            // Apply changes required by the options (possible to override appVersion is expected)
            if (options.config) {
                for (const key of Object.keys(options.config)) {
                    instance.set(key, options.config[key]);
                }
            }
        };
        this.loadScript(`https://static.bolt.eu/applog/${APPLOG_VERSION}/applog.js`);
    }
    loadScript(source, async = true) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = source;
            if (source.startsWith("http")) {
                const url = new URL(source);
                // Otherwise you will lose global onerror, which leads to errors not being reported correctly
                // Explained in https://javascript.info/onload-onerror
                if (url.hostname !== window.location.hostname) {
                    script.crossOrigin = "anonymous";
                }
            }
            script.onload = () => resolve();
            script.async = async;
            document.body.appendChild(script);
        });
    }
}
exports.App = App;
//# sourceMappingURL=App.js.map